module.exports = __webpack_public_path__ + "static/media/codeInLogo.47a7a717.webp";